import { render, staticRenderFns } from "./StockMFIView.vue?vue&type=template&id=dcf5826e&scoped=true"
import script from "./StockMFIView.vue?vue&type=script&lang=js"
export * from "./StockMFIView.vue?vue&type=script&lang=js"
import style0 from "./StockMFIView.vue?vue&type=style&index=0&id=dcf5826e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf5826e",
  null
  
)

export default component.exports